// @ts-strict-ignore
import { Checkbox, CheckboxProps } from './Checkbox'
import { FieldControl } from './FieldControl'
import { Input, InputProps } from './Input'
import { Select, SelectProps } from './Select'
import { Textarea, TextareaProps } from './Textarea'
import { cn } from '@lib/cn'
import { useField } from 'formik'
import { useTranslation } from 'next-i18next'
import React, { FC } from 'react'

type InputType = InputProps & {
  field: 'input'
}

type TextareaType = TextareaProps & {
  field: 'textarea'
}
type SelectType = SelectProps & {
  field: 'select'
}
type CheckboxType = CheckboxProps & {
  field: 'checkbox'
}

type FieldType = InputType | TextareaType | SelectType | CheckboxType

type Props = {
  label?: React.ReactNode | string
  assistiveText?: string
  errorMsg?: string
  className?: string
}

export const Field: FC<FieldType & Props> = ({
  field = 'input',
  label,
  assistiveText,
  className,
  ...rest
}) => {
  const { t } = useTranslation('rolex')
  const [fieldProps, meta] = useField<any>(rest.name)
  const error = meta.error?.replace('forms.', '')
  switch (field) {
    case 'input':
      return (
        <FieldControl
          className={className}
          label={label}
          assistiveText={assistiveText}
          errorMsg={meta.touched && meta.error ? t(error, { ns: 'rolex' }) : undefined}
        >
          {/*
          // @ts-ignore */}
          <Input {...fieldProps} {...rest} />
        </FieldControl>
      )
    case 'textarea':
      return (
        <FieldControl
          className={className}
          assistiveText={assistiveText}
          errorMsg={meta.touched && meta.error ? t(error, { ns: 'rolex' }) : undefined}
        >
          {/*
          // @ts-ignore */}
          <Textarea {...fieldProps} {...rest} />
        </FieldControl>
      )
    case 'select':
      return (
        <FieldControl
          className={className}
          assistiveText={assistiveText}
          label={label}
          errorMsg={meta.touched && meta.error ? t(error, { ns: 'rolex' }) : undefined}
        >
          {/*
          // @ts-ignore */}
          <Select {...fieldProps} {...rest} />
        </FieldControl>
      )
    case 'checkbox':
      return (
        <FieldControl
          className={cn('-mt-2 mb-0', className)}
          isCheckbox
          assistiveText={assistiveText}
          errorMsg={meta.touched && meta.error ? t(error, { ns: 'rolex' }) : undefined}
        >
          {/*
          // @ts-ignore */}
          <Checkbox checked={fieldProps.value} label={label} {...fieldProps} {...rest} />
        </FieldControl>
      )
    default:
      return null
  }
}
